/* eslint-disable no-use-before-define */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { set, setCustomer, setIsLoadingLoaded, clear, clearSelectedFilters, selectFilterItem, unselectFilterItem } from './actions';
import { fetchReportsAggsFilters } from '../../../api/reportsaggsfilters';
import {
	selectCustomer,
	selectFilters,
	selectFilterItems,
	selectSelectedFiltersMap,
	selectIsLoaded,
	selectIsLoading
} from '../selectors';
import {
	selectIsLoaded as selectIsLoadedReports,
	selectIsLoading as selectIsLoadingReports,
	selectItems as selectReports,
} from '../../ReportsAggs/selectors';
import UTIL from '../util.selectedFilters';
import RADF_UTIL from '../util.urlWriter';
import { injectDynamicFilters } from '../../../api/util/reportaggsfilters';

const thunkLoad = () => (dispatch, getState) => {
  const customerName = selectCustomer(getState());

  dispatch(clear());
  dispatch(setCustomer(customerName));
	dispatch(
		setIsLoadingLoaded({
			isLoading: true,
			isLoaded: false
		})
	);
  fetchReportsAggsFilters(customerName).then((filters) => {
		dispatch(set(filters));
		dispatch(
			setIsLoadingLoaded({
				isLoading: false,
				isLoaded: true
			})
		);
		dispatch(thunkInjectDynamicFilters());
    dispatch(thunkLoadStateFromUrl());
	});
};

const thunkSetCustomerName = (customerName) => (dispatch) => { 
  dispatch(setCustomer(customerName));
  dispatch(clearSelectedFilters());
  dispatch(thunkLoad());
}

const thunkClearSelectedFilters = () => (dispatch) => { 
  dispatch(clearSelectedFilters());
  RADF_UTIL.clearUrl();
}

const thunkUnselectFilterItem = (filterKey, item, { preventUrlWrite = false } = {}) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (currIsSelected) {
    dispatch(unselectFilterItem(filterKey, item));
    if (!preventUrlWrite) {
      RADF_UTIL.removeFromUrl(filterKey, item);
    }
  }
}

const thunkSelectFilterItem = (filterKey, item, { preventUrlWrite = false } = {}) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (!currIsSelected) {
    dispatch(selectFilterItem(filterKey, item));
    if (!preventUrlWrite) {
      RADF_UTIL.addToUrl(filterKey, item);
    }
  }
}

const thunkToggleFilterItem = (filterKey, item) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (currIsSelected) {
    dispatch(thunkUnselectFilterItem(filterKey, item));
  } else { 
    dispatch(thunkSelectFilterItem(filterKey, item));
  }
}

const thunkLoadStateFromUrl = () => (dispatch, getState) => { 
  if (!RADF_UTIL.CACHE.isLoaded) {
    RADF_UTIL.loadCacheFromUrl();
    const { FILTERS: URL_FILTERS } = RADF_UTIL.CACHE;
    const filterKeys = Object.keys(URL_FILTERS);

    filterKeys.forEach((filterKey) => {
      // identify selected ids
      const ids = URL_FILTERS[filterKey];
      const idsMap = ids.reduce((acc, id) => {
        acc[id] = true;
        return acc;
      }, {});

      // Map IDs to Existing Objects
      const possibleFilters = selectFilterItems(getState(), filterKey);
      const selectedFilters = possibleFilters.map(item => ((idsMap[item.id] && item) || undefined)).filter(v => v);
      selectedFilters.forEach(item => {
        dispatch(thunkSelectFilterItem(filterKey, item, { preventUrlWrite: true }));
      });
    });
  }
}

const thunkInjectDynamicFilters = () => (dispatch, getState) => {
	const customer = selectCustomer(getState());

	const isLoadedFilters = selectIsLoaded(getState());
	const isLoadingFilters = selectIsLoading(getState());
	const filters = selectFilters(getState());
	const isFiltersReady = isLoadedFilters && !isLoadingFilters && filters;

	const isLoadedReports = selectIsLoadedReports(getState());
	const isLoadingReports = selectIsLoadingReports(getState());
	const reportaggs = selectReports(getState());
	const isReportsReady = isLoadedReports && !isLoadingReports && reportaggs;

	if (isFiltersReady && isReportsReady) {
		const modifiedFilters = injectDynamicFilters(customer, filters, reportaggs);
		dispatch(set(modifiedFilters));
	}
}

export {
  thunkClearSelectedFilters,
  thunkUnselectFilterItem,
  thunkSelectFilterItem,
  thunkLoad,
  thunkSetCustomerName,
	thunkToggleFilterItem,
	thunkInjectDynamicFilters
};
